import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Breadcrumb } from '@markant-platform/shared/breadcrumb/feature';
import { map, Observable, switchMap } from 'rxjs';
import { OrganizationService } from '@markant-platform/shared/organization/data-access';

@Injectable({
  providedIn: 'root',
})
export class OrganizationDetailsFormBreadcrumbResolver {
  organizationService = inject(OrganizationService);

  resolve(route: ActivatedRouteSnapshot): Observable<Breadcrumb[]> {
    const url = route.routeConfig?.path?.split('/')[0] ?? '';

    return this.organizationService.getOrganizationId().pipe(
      switchMap(userOrgId => {
        const organizationId = route?.paramMap?.get('organizationId');
        return this.organizationService.getOrganizationDetailsById(organizationId ?? userOrgId);
      }),
      map(({ name }) => [
        {
          label: '',
          url,
          translateParams: {
            organizationName: name,
          },
          translateLabel: 'organization.breadcrumb.edit',
        },
      ])
    );
  }
}
